export default __webpack_public_path__ + "src/assets/icn-close.0db1fb36257789facca21d9540b7076b.svg";